@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.root {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.footerContainer {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--light-100);
  max-height: 300px;
  z-index: 100;

  [data-autopilot-system-redesign='on'] & {
    background: #f4f5f5;
  }
}
